<template>
  <main class="page-operative page-operative-data-analysis page-operative-data-analysis-crediti-imposta page-operative-crediti-imposta-new">
    <div class="container">
      <div class="d-flex align-items-center justify-content-between mb-5">
        <PageTitle>Nuovo credito</PageTitle>
        <app-router-link class="btn btn-outline-primary" :to="{ name: 'operative-company.data-analysis.crediti-imposta' }">Torna alla lista</app-router-link>
      </div>

      <FormCreditiImposta @saved="saveCredito" />
    </div>
  </main>
</template>

<script>

import operativePageMixin from '../../../../../mixins/operativePage';

export default {
  name: 'page-operative-company-data-analysis-finanziamenti-new',
  mixins: [operativePageMixin],
  components: {
    PageTitle: () => import('../../../../components/Layout/LayoutOperative/PageTitle'),
    FormCreditiImposta: () => import('../../../../components/Operative/Form/FormCreditiImposta'),
    AppRouterLink: () => import('../../../../components/Layout/AppRouterLink'),
  },
  methods: {
    saveCredito (credito) {
      this.$api.addCreditoImposta(this.company.id, credito)
        .then(() => {
          this.$router.push({
            name: 'operative-company.data-analysis.crediti-imposta',
            query: {
              forecast: this.$route.query?.forecast || null,
            },
          });
        })
        .catch(this.$log.error)
      ;
    },
  },
};

</script>
